import { createSlice } from "@reduxjs/toolkit";
import { RequestResults } from "../../common/RequestStatus";
import { getCustomerDetails } from "./customerAsyncThunk";
import { CustomerDetails } from "../../../types";
import { RootState } from "../../store";

interface CustomerLists {
    data: CustomerDetails[];
    counts: number;
    filteredCount: number;
    draftIncompleteUserCount: number;
    draftCompletedUserCount: number;
    notPaidUserCount: number;
    overdueClaimUserCount: number;
    overdueCount: number;
    paidCount: number;
    paymentFailedCount: number;
    neverPaidCount: number;
    overdueSoon7dCount: number;
    overdueSoon3dCount: number;
    overdueSoon1dCount: number;
    paidOverdueCount: number;
    otherNeverPaidCount: number;
    refundedCount: number;
    limit: number;
    page: number;
    status: RequestResults;
    error: string | null;
}
const initialState: CustomerLists = {
        data: [],
        counts: 0,
        filteredCount: 0,
        draftIncompleteUserCount: 0,
        draftCompletedUserCount: 0,
        notPaidUserCount: 0,
        overdueClaimUserCount: 0,
        overdueCount: 0,
        paidCount: 0,
        paymentFailedCount: 0,
        neverPaidCount: 0,
        overdueSoon7dCount: 0,
        overdueSoon3dCount: 0,
        overdueSoon1dCount: 0,
        paidOverdueCount: 0,
        otherNeverPaidCount: 0,
        refundedCount: 0,
        limit: 10,
        page: 1,
        status: RequestResults.idle,
        error: null,
};

const customerSlice = createSlice({
    name: "customerList",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCustomerDetails.pending, (state) => {
                state.status = RequestResults.pending;
            })
            .addCase(getCustomerDetails.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.counts = action.payload.counts;
                state.filteredCount = action.payload.filteredCount || action.payload.counts;
                state.draftIncompleteUserCount = action.payload.draftIncompleteUserCount || 0;
                state.draftCompletedUserCount = action.payload.draftCompletedUserCount || 0;
                state.notPaidUserCount = action.payload.notPaidUserCount || 0;
                state.overdueClaimUserCount = action.payload.overdueClaimUserCount || 0;
                state.overdueCount = action.payload.overdueCount || 0;
                state.paidCount = action.payload.paidCount || 0;
                state.paymentFailedCount = action.payload.paymentFailedCount || 0;
                state.neverPaidCount = action.payload.neverPaidCount || 0;
                state.overdueSoon7dCount = action.payload.overdueSoon7dCount || 0;
                state.overdueSoon3dCount = action.payload.overdueSoon3dCount || 0;
                state.overdueSoon1dCount = action.payload.overdueSoon1dCount || 0;
                state.paidOverdueCount = action.payload.paidOverdueCount || 0;
                state.otherNeverPaidCount = action.payload.otherNeverPaidCount || 0;
                state.refundedCount = action.payload.refundedCount || 0;
                state.limit = action.payload.limit;
                state.status = RequestResults.success;
            })
            .addCase(getCustomerDetails.rejected, (state, action) => {
                state.status = RequestResults.failed;
                // @ts-ignore
                state.error = action.payload || "Failed to fetch email logs";
            })
    },
});

export const customerListDetail = (state: RootState) => state.customerList;

export default customerSlice.reducer;
